import clsx from "clsx";
import { LoaderIcon } from "./LoaderIcon";
import { useTranslate } from "@/hooks/use-translate/useTranslate";

interface LoaderProps {
  full?: boolean;
  fullScreen?: boolean;
}

export const Loader = ({ full, fullScreen }: LoaderProps) => {
  const translate = useTranslate();
  return (
    <div
      data-testid="loader"
      className={clsx(
        full && "h-full",
        fullScreen && "absolute h-full w-[100vw] top-0",
        "flex flex-col items-center justify-center space-y-2 z-[1005] bg-gray-500/20",
      )}
    >
      <div className="spi">
        <LoaderIcon className="animate-spin-slow" />
      </div>
      <p className="text-xl">{translate("loading")}...</p>
    </div>
  );
};
